import React from 'react';
import styled from 'styled-components';
import { Box, Text } from '@99designs/emu';
import { spaces } from '@99designs/emu/settings';
import StatBarChart from '../Chart/StatBarChart';

const Wrapper = styled.div`
    display: flex;
    height: 190px;
`;

interface Props {
    calloutStat: string;
    calloutDescription: string;
    score: number;
    barChartColor: string;
}

export default function DiversityBarChart({
    calloutStat,
    calloutDescription,
    score,
    barChartColor,
}: Props) {
    return (
        <Wrapper>
            <StatBarChart score={score} color={barChartColor} direction="vertical" />
            <Box display="flex" paddingLeft="1.5bu" flexDirection="column">
                <Text
                    size="size9"
                    fontFamily="attribution"
                    lineHeight="h2"
                    italic={true}
                    style={{ marginTop: spaces['1bu'] }}
                >
                    {calloutStat}
                </Text>
                <Text
                    size="size4"
                    fontFamily="attribution"
                    italic={true}
                    lineHeight="h5"
                    style={{ marginTop: spaces['0.75bu'] }}
                >
                    {calloutDescription}
                </Text>
            </Box>
        </Wrapper>
    );
}
